var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.open,
          expression: "open",
        },
      ],
      staticClass: "accountHeaderModal",
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.clickOutside,
            expression: "clickOutside",
          },
        ],
        class: {
          headerIcon: true,
          pressed: _vm.open,
        },
        on: { click: _vm.toggleOpen },
      },
      [
        _vm.unreadMessageCount > 0
          ? _c("span", { staticClass: "unreadMessageBadge" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.unreadMessageCount) + "\n\t\t"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("i", { staticClass: "accountIcon" }),
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.open,
            expression: "open",
          },
        ],
        staticClass: "harmonica",
      },
      [
        _c("li", { staticClass: "header" }, [
          _c("i", { staticClass: "accountIcon" }),
          _vm._v(" "),
          _c("span", [
            _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("myAccount")) + "\n\t\t\t"),
          ]),
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.goToShelf } }, [
          _c("span", [
            _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("headerShelf")) + "\n\t\t\t"),
          ]),
        ]),
        _vm._v(" "),
        _vm.showAccount && _vm.user.id > 0 && _vm.user.temporary === 0
          ? _c("li", { on: { click: _vm.goToAccount } }, [
              _c("span", [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("myAccount")) + "\n\t\t\t"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showInbox
          ? _c("li", { on: { click: _vm.goToInbox } }, [
              _c(
                "span",
                {
                  class: {
                    bold: _vm.unreadMessageCount > 0,
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("views.headerAccount.inbox")) +
                      _vm._s(
                        _vm.unreadMessageCount > 0
                          ? " (" + _vm.unreadMessageCount + ")"
                          : ""
                      ) +
                      "\n\t\t\t"
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showAccount && _vm.user.id > 0 && _vm.user.temporary === 0
          ? _c("li", { on: { click: _vm.goToAccountPhotos } }, [
              _c("span", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("importHistoryHeader")) +
                    "\n\t\t\t"
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        (_vm.user.id === null || _vm.user.temporary === 1) && _vm.hasLogin
          ? _c("li", { on: { click: _vm.goToLogin } }, [
              _c("span", [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("login")) + "\n\t\t\t"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.user.id === null || _vm.user.temporary === 1
          ? _c("li", { on: { click: _vm.goToSignup } }, [
              _c("span", [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t("createaccount")) + "\n\t\t\t"
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.user.id > 0
          ? _c("li", { on: { click: _vm.goToLogout } }, [
              _c("span", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.user.temporary
                        ? _vm.$t("logoutGuest")
                        : _vm.$t("logout")
                    ) +
                    "\n\t\t\t"
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "footer", on: { click: _vm.userSettings } }, [
          _c("span", [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.$t("views.headerAccount.languageCountry")) +
                "\n\t\t\t"
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }